import { render } from "./OwnerCourses.vue?vue&type=template&id=44c47a42&scoped=true"
import script from "./OwnerCourses.vue?vue&type=script&lang=js"
export * from "./OwnerCourses.vue?vue&type=script&lang=js"

import "./OwnerCourses.vue?vue&type=style&index=0&id=44c47a42&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c47a42"]])

export default __exports__